import { render, staticRenderFns } from "./EditNewsletter.vue?vue&type=template&id=26fab5f1&"
import script from "./EditNewsletter.vue?vue&type=script&lang=ts&"
export * from "./EditNewsletter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports